export default __webpack_public_path__ + "static/media/your-modules-icon.b16a2c09.svg";